import React from "react";
import { T } from "../app/tokens.js";

export function OfficeNameLabel({ city, alias, locationId }) {
  if (city) {
    return (
      <>
        <span style={{ fontWeight: T.fwSemibold, color: T.dark }}>{city}</span>
        {alias && (
          <span style={{ fontWeight: T.fwRegular, color: T.mid }}>{" · "}{alias}</span>
        )}
      </>
    );
  }
  return (
    <span style={{ fontWeight: T.fwSemibold, color: T.dark }}>
      {alias || locationId || "—"}
    </span>
  );
}
